import { render, staticRenderFns } from "./consignmentReturn.vue?vue&type=template&id=1b2df3ac&scoped=true"
import script from "./consignmentReturn.vue?vue&type=script&lang=js"
export * from "./consignmentReturn.vue?vue&type=script&lang=js"
import style0 from "./consignmentReturn.vue?vue&type=style&index=0&id=1b2df3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2df3ac",
  null
  
)

export default component.exports